import jQuery from 'jquery';
import gsap from "gsap";
import { DrawSVGPlugin } from "./vendor/gsap/DrawSVGPlugin";
import SmoothScrollbar from 'smooth-scrollbar';
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollTriggerPlugin from './vendor/ScrollTriggerPlugin';
import SoftScrollPlugin from './vendor/SoftScrollPlugin';
import autosize from 'autosize';
import { Fancybox } from "@fancyapps/ui";
import hljs from 'highlight.js';
import SimpleJqueryAccordion from "./vendor/SimpleJqueryAccordion";

hljs.highlightAll();

SmoothScrollbar.use(ScrollTriggerPlugin, SoftScrollPlugin);

window.$ = window.jQuery = jQuery;

window.Brilliance = {};

gsap.registerPlugin(DrawSVGPlugin);

// Loader
$(window).on('load', function() {
	$( ".my-loader" ).removeClass( "-visible" );
  $( ".my-drawer-nav" ).removeClass( "-hidden" );
});


// // Drawer
$('.my-drawer-toggle').click( function(){
	$('.my-drawer').toggleClass('my-drawer--open');
	$('.my-btn_menu').toggleClass('-active');
});

$('.my-drawer-close').click(function() {
	$('.my-drawer').removeClass('my-drawer--open');
	$('.my-btn_menu').removeClass('-active');
});

$('.my-drawer-overlay').click(function() {
	$('.my-drawer').removeClass('my-drawer--open');
	$('.my-btn_menu').removeClass('-active');
});



// FANCYBOX
Fancybox.bind('[data-fancybox]', {
  // Do not hide page scrollbars
  hideScrollbar: false,

  // Disable drag to close guesture
  dragToClose: true,

  // Hide close button
  // closeButton: false,
  touch: false,

  autoFocus: false,

  trapFocus: false,

  placeFocusBack: false,

  // Disable toolbar
  Toolbar: false,

  // Disabble Zoom for the custom annimation fancybox-zoomIn & fancybox-zoomOut
  zoom: false,

  closeButton: "outside",

  // dragToClose: false,
  showClass: "fancybox-zoomIn",
  hideClass: "fancybox-zoomOut",
  // animationDuration : 600,
  // animationEffect   : 'scale-in-out'
});



// DRAWER 100VH INCLUDING URL BAR

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});


$(document).ready(function() {
  if(document.querySelector("textarea")) {
    var ta = document.querySelector('textarea');
    autosize(ta);
  };
});


// Check if is mobile device
function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};

window.Brilliance.isMobileDevice = isMobileDevice;


// ============= REMOVE ALL # FROM URL BAR WHEN CLICKING LINK
//Get all the hyperlink elements
var links = document.getElementsByTagName("a");

//Browse the previously created array
Array.prototype.forEach.call(links, function(elem, index) {
  //Get the hyperlink target and if it refers to an id go inside condition
  var elemAttr = elem.getAttribute("href");
  if(elemAttr && elemAttr.includes("#")) {
    //Replace the regular action with a scrolling to target on click
    elem.addEventListener("click", function(ev) {
      ev.preventDefault();
      //Scroll to the target element using replace() and regex to find the href's target id
      document.getElementById(elemAttr.replace(/#/g, "")).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
          });
    });
  }
});

// ============================================ ATTACHMENT =======================================================

'use strict';

;( function( $, window, document, undefined )
{
  $( '.my-inputfile' ).each( function()
  {
    var $input   = $( this ),
      $label   = $input.next( 'label' ),
      labelVal = $label.html();

    $input.on( 'change', function( e )
    {
      var fileName = '';

      if( this.files && this.files.length > 1 )
        fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
      else if( e.target.value )
        fileName = e.target.value.split( '\\' ).pop();

      if( fileName )
        $label.find( 'span' ).html( fileName );
      else
        $label.html( labelVal );
    });

    // Firefox bug fix
    $input
    .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
    .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
  });
})( jQuery, window, document );


// ============================================= SMOOTH SCROLL & GSAP ====================================================

//Disable mobile resize to fix the bug on mobile with the URL bar
ScrollTrigger.config({ ignoreMobileResize: true });


//Reload page for GSAP if the mobile oriantation has changed
function doOnOrientationChange() {
    switch(window.orientation) {
      case 90:
        location.reload();
        break;
      case -90:
        location.reload();
        break;
      case 0:
        location.reload();
        break;
      case 180:
        location.reload();
        break;
      default:
        break;
    }
}

window.addEventListener('orientationchange', doOnOrientationChange);


// Enable smooth scall on Desktop
if (!isMobileDevice()) {
  // Init smooth scrollbar
  const view = document.getElementById('view-main');
  const scrollbar = SmoothScrollbar.init(view, {
      renderByPixels: true,
      damping: 0.085
  });

  // Autoscroll on Desktop
  $(".autoscroll-link").click(function(e){
      var href = $(this).attr('href');
      scrollbar.scrollIntoView(document.querySelector(href), {
      offsetTop: $.isNumeric($(this).data('offset')) ? parseInt($(this).data('offset')) : 100,
      alignToTop: true,
    });
  });
};

gsap.config({
  force3D: true,
});

ScrollTrigger.saveStyles(".my-footer");

ScrollTrigger.matchMedia({
	"(min-width: 1024px)": function() {
    // About block animation
    if(document.querySelector(".my-services__block")) {
      if (!isMobileDevice()) {
        (function () {
          let blocks = gsap.utils.toArray('.my-services__block');
          let length = blocks.length-1
          blocks.forEach((item, index) => {
            let tl = gsap.timeline({
              scrollTrigger: {
                trigger: item,
                endTrigger: blocks[length],
                start: "center center",
                end: "center center",
                pin: true,
                pinSpacing: false,
                scrub: true,
                anticipatePin: 1,
              },
            });

            let tl2 = gsap.timeline({
              scrollTrigger: {
                trigger: blocks[0],
                endTrigger: blocks[1],
                start: "center center",
                end: "center center",
                scrub: true,
              },
            });

             let tl3 = gsap.timeline({
              scrollTrigger: {
                trigger: blocks[length-1],
                endTrigger: blocks[length],
                start: "center center",
                end: "center center",
                scrub: true,
              },
            });

            if (index == 0) {
              tl2.to(item, {
                yPercent: -16,
                scale: 0.90,
                ease: "none",
              }, 0);
            }

            if (index == 1) {
              tl3.to(item, {
                yPercent: -8,
                scale: 0.95,
                ease: "none",
              }, 0);
            }
          });
        })();
      }
    }

    // Navigation Pinning
    // if (!isMobileDevice()) {
    //   (function () {
    //     const nav = document.querySelector(".my-navbar-col.-right");
    //     const container = document.querySelector(".my-layout");

    //     let tl = gsap.timeline({
    //       scrollTrigger: {
    //         trigger: container,
    //         start: "top top",
    //         end: "bottom top",
    //         pin: nav,
    //         pinSpacing: false,
    //         scrub: true,
    //         anticipatePin: 1,
    //       },
    //     });
    //   })();
    // }


    // Contact image pin
    if (!isMobileDevice()) {
      (function () {
        const image = document.querySelector(".my-contact__img img");
        const container = document.querySelector(".my-contact");
        const containerEnd = document.querySelector(".footer-radius");

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: container,
            endTrigger: containerEnd,
            start: "top top",
            end: "bottom bottom",
            pin: image,
            pinSpacing: false,
            scrub: true,
            anticipatePin: 1,
          },
        });
      })();
    }

    // Footer animation
    if (!isMobileDevice()) {
      (function () {
        const footer = document.querySelector(".my-footer");
        const end = document.querySelector(".my-layout");

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: footer,
            endTrigger: end,
            start: "top bottom",
            end: "bottom bottom",
            scrub: true,
          },
        });

        tl.fromTo(footer, {
          yPercent: -30,
        }, {
          yPercent: 0,
          ease: "none",
        }, 0);
      })();
    }
	},

	// "(min-width: 1200px) and (max-width: 1599px)": function() {

	// },

  "(min-width: 768px)": function() {
    // Side scrolling text animations
    if(document.querySelector(".my-ship")) {
      (function () {
        const ship = document.querySelector(".my-ship");

          let tl = gsap.timeline({
            scrollTrigger: {
              trigger: ship,
              start: "top bottom",
              end: "bottom top",

              onEnter: () => {
                tl.play()
              },
              onLeave: () => {
                tl.pause()
              },
              onEnterBack: () => {
                tl.play()
              },
              onLeaveBack: () => {
                tl.pause()
              },
            },
          });

          tl.to(ship, 11, {
            ease: "none",
            xPercent: 340, //move each box 100% to right
            modifiers: {
              x: gsap.utils.unitize(x => parseFloat(x) % distance) //force x value to be between 0 and 500 using modulus
            },
            repeat: -1
          });
      })();
    }
  },

	"all": function () {
    if(document.querySelector(".my-card")) {
      // Cards animation
      if (!isMobileDevice()) {
        (function () {
          initCardAnimation();
        })();
      }
    }

    // Link line animation
    if(document.querySelector(".my-link-more__line")) {
      if (!isMobileDevice()) {
        (function () {
          // let line = document.querySelector('.my-link-more__line path');
          let line = gsap.utils.toArray('.my-link-more__line path');

          line.forEach((item, index) => {

            let tl = gsap.timeline();

            tl.fromTo(item, {drawSVG:"0"}, {duration: 1, drawSVG:"100%", ease: "Power1.easeOut"});

            const pathParent = $( item ).parent();
            const link = $( pathParent ).parent();
            $(link).hover(over, out);

            function out() {
              tl.play();
            }

            function over() {
              tl.reverse();
            }
          });
        })();
      }
    }
	}
});



// Refresh GSAP on window resize on Desktop
if (!isMobileDevice()) {
	$(window).resize(function() {
    setTimeout(function(){
  		ScrollTrigger.refresh();
  		ScrollTrigger.update();
    }, 300);
	});
}

/*const contactForm = document.getElementById("contact-form");
contactForm.addEventListener("freeform-ajax-success", function (event) {
	$('#contact-form').addClass('hidden');
	$('#success-message').removeClass('hidden');
});

document.addEventListener("freeform-render-field-errors", function (event) {
  // Stop the default field error rendering
  event.preventDefault();

  const form = event.form;
  const errors = event.errors;

  for (const fieldHandle in errors) {
    // Log each field errors to the console
    if (fieldHandle == 'name') {
      $('#name-error').removeClass('hidden');
      $('#name-label').addClass('invalid');
    } else if (fieldHandle =='email') {
      $('#email-error').removeClass('hidden');
      $('#email-label').addClass('invalid');
    } else if (fieldHandle == 'message') {
      $('#message-error').removeClass('hidden');
      $('#message-label').addClass('invalid');
    }
  }
});

document.getElementById("name").addEventListener('focus', (event) => {
	$('#name-label').removeClass('invalid');
	$('#name-error').addClass('hidden');
});
document.getElementById("email").addEventListener('focus', (event) => {
	$('#email-label').removeClass('invalid');
	$('#email-error').addClass('hidden');
});
document.getElementById("message").addEventListener('focus', (event) => {
	$('#message-label').removeClass('invalid');
	$('#message-error').addClass('hidden');
});*/


const accordion = new SimpleJqueryAccordion();
accordion.init('accordion');

function initCardAnimation() {
  let cards = gsap.utils.toArray('.my-card');

  cards.forEach((item, index) => {
    const cardContent = item.querySelector(".my-card__content");

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: "top bottom",
        end: "center center",
        scrub: true,
      },
    });

    tl.fromTo(cardContent, {
      yPercent: -100,
    }, {
      yPercent: 0,
      ease: "none",
    }, 0);
  });
}

window.Brilliance.initCardAnimation = initCardAnimation;